import React from 'react'
import {Link} from 'react-router-dom';
import Plier from '../../img/plier/plier-two.png';
import CompountWireCutter from '../../img/compoundwirecutter/wirecutter-empty.png';
import SoilAuger from '../../img/auger/auger-empty.png';
const ToolKitNav = () => {
    return (
        <div className='d-flex justify-content-center align-items-center tool-kit'>
            <Link to='/plier'><img className='tool-kit-img' src={Plier}/></Link>
            <Link to='/soilauger'><img className='tool-kit-img' src={SoilAuger}/></Link>
            <Link to='/compoundwirecutter'><img className='tool-kit-img' src={CompountWireCutter}/></Link>
        </div>
    )
}

export default ToolKitNav
